import type { FC } from "react"

import { InputField } from "commons"

const OnboardingStepName: FC<Props> = ({ organizationName }) => (
  <div className="flex flex-col gap-6 md:gap-8">
    <div className="flex flex-col gap-2">
      <h2 className="text-2xl leading-6  font-semibold text-gray-900">What&apos;s your full name?</h2>
      {organizationName && <p className="text-base leading-5 text-gray-500">{organizationName}</p>}
    </div>
    <div className="grid grid-cols-1 md:!grid-cols-2 gap-4 md:gap-6">
      <InputField field="firstName" label="First name" blockSpecialChars inputClassName="!h-[2.625rem]" />
      <InputField field="lastName" label="Last name" blockSpecialChars inputClassName="!h-[2.625rem]" />
    </div>
  </div>
)

type Props = {
  organizationName?: string
}

export { OnboardingStepName }
